import React from "react";

const POINTS = [
  { title: "Lost context", copy: "Decisions, drafts and feedback scatter across disconnected tools until the thread of the work is lost." },
  { title: "Fragmented review", copy: "Feedback and approvals arrive in separate places, slowing decisions and weakening accountability." },
  { title: "Manual handoffs", copy: "Approved work still moves by hand between creation, collaboration, scheduling and publishing." },
];

export default function Problem() {
  return (
    <section id="problem" className="z-section-compact" data-testid="problem">
      <div className="z-page">
        <p className="z-eyebrow" data-testid="problem-eyebrow">The problem</p>
        <h2 className="mt-3 font-display text-[28px] md:text-[38px] leading-[1.12] max-w-[25ch]">AI creates faster. Professional work still breaks between tools.</h2>
        <div className="mt-8 grid gap-3 md:gap-4 md:grid-cols-3">
          {POINTS.map((p) => <div key={p.title} className="z-card-compact px-5 py-5 md:px-6" data-testid={`problem-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}><h3 className="font-display text-[17px] md:text-[18px] text-[hsl(var(--z-text))]">{p.title}</h3><p className="mt-2 text-[15px] leading-[1.55] text-[hsl(var(--z-text-muted))]">{p.copy}</p></div>)}
        </div>
        <p className="mt-8 max-w-[64ch] text-[16px] md:text-[17px] leading-[1.65] text-[hsl(var(--z-text))]">Culmora OS is being built to keep creation, collaboration, review and approved execution inside one professional workflow.</p>
      </div>
    </section>
  );
}
